module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("Daily Light: Morning & Evening")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "page30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1a#cc31",
      "id": "dd31"
    }
  }, [_c('i', [_vm._v("January 29")])])]), _vm._v(" "), _c('p', {
    staticClass: "txl1",
    attrs: {
      "id": "amJanuary29"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORNING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0034-03-2"
    }
  }, [_c('span', [_c('i', [_vm._v("You-Are-the-God-Who-Sees.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0034-04-3"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("O")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", You have searched me and known me. You know my sitting down and my rising up; You understand my thought afar off. You comprehend my path and my lying down, and are acquainted with all my ways. For there is not a word on my tongue, but behold, O L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", You know it altogether. Such knowledge is too wonderful for me; it is high, I cannot attain it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-05-5"
    }
  }, [_vm._v("The eyes of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" are in every place, keeping watch on the evil and the good. • The ways of man are before the eyes of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", and He ponders all his paths. • God knows your hearts. For what is highly esteemed among men is an abomination in the sight of God. • The eyes of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" run to and fro throughout the whole earth, to show Himself strong on behalf of those whose heart is loyal to Him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-05-6"
    }
  }, [_vm._v("Jesus . . . knew all men, and had no need that anyone should testify of man, for He knew what was in man. • Lord, You know all things; You know that I love You.")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")]), _vm._v(". 16:13; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(". 139:1–4, 6; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROV")]), _vm._v(". 15:3; 5:21; L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UKE")]), _vm._v(" 16:15; 2 C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRON")]), _vm._v(". 16:9; J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" 2:24–25; 21:17")]), _vm._v(" "), _c('p', {
    staticClass: "txl1",
    attrs: {
      "id": "aeJanuary29"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VENING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0034-08-10"
    }
  }, [_c('span', [_c('i', [_vm._v("I will praise You, O Lord my God, with all my heart, and I will glorify Your name forevermore.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0034-09-12"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("W")]), _vm._v("hoever offers praise glorifies Me. • It is good to give thanks to the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", and to sing praises to Your name, O Most High; to declare Your lovingkindness in the morning, and Your faithfulness every night.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-10-15"
    }
  }, [_vm._v("Let everything that has breath praise the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-10-16"
    }
  }, [_vm._v("I beseech you, brethren, by the mercies of God, that you present your bodies a living sacrifice, holy, acceptable to God, which is your reasonable service. • Jesus also, that He might sanctify the people with His own blood, suffered outside the gate. . . . Therefore by Him let us continually offer the sacrifice of praise to God, that is, the fruit of our lips, giving thanks to His name. • Giving thanks always for all things to God the Father in the name of our Lord Jesus Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-10-17"
    }
  }, [_vm._v("Worthy is the Lamb who was slain to receive power and riches and wisdom, and strength and honor and glory and blessing!")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(". 86:12; 50:23; 92:1–2; 150:6; R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OM")]), _vm._v(". 12:1; H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EB")]), _vm._v(". 13:12, 15; E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PH")]), _vm._v(". 5:20; R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EV")]), _vm._v(". 5:12")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0920d34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter31.vue
// module id = 156
// module chunks = 0